/*
  Phase 2 API client — STT, Auto-Scheduler, Routines.
  Keeps a single entry point so pages don't reach into axios directly.
*/
import axios from "axios";
import { API, getClientId } from "./api";

const http = axios.create({ baseURL: API });
http.interceptors.request.use((cfg) => {
  cfg.headers["X-Client-Id"] = getClientId();
  return cfg;
});

export const phase2Api = {
  // Speech-to-text
  async transcribe(audioBlob) {
    const fd = new FormData();
    fd.append("file", audioBlob, "recording.webm");
    const { data } = await http.post("/stt", fd, { headers: { "Content-Type": "multipart/form-data" } });
    return data; // { text, language, duration }
  },

  // Auto-Scheduler
  async proposeSchedule(params = {}) {
    const { data } = await http.post("/schedule/propose", params);
    return data;
  },
  async commitSchedule(proposals) {
    const { data } = await http.post("/schedule/commit", { proposals });
    return data;
  },

  // Routines
  async listRoutines() { return (await http.get("/routines")).data; },
  async createRoutine(body) { return (await http.post("/routines", body)).data; },
  async updateRoutine(id, patch) { return (await http.patch(`/routines/${id}`, patch)).data; },
  async deleteRoutine(id) { return (await http.delete(`/routines/${id}`)).data; },
  async suggestRoutine(time_of_day) {
    return (await http.post("/routines/suggest", { time_of_day })).data;
  },
};
